import { LayoutSchemaField } from "@mapmycustomers/shared/types/layout/FormLayout";

const isRequiredLayoutSchemaField = (row: LayoutSchemaField): boolean =>
  row?.required && row.fieldType !== "divider";

export default isRequiredLayoutSchemaField;
